import { useState, useRef, useEffect } from "react";
import { Controller } from "react-hook-form";
import { RiCalendar2Line } from "react-icons/ri";

const TimelineCalendar = ({ name, value, frequency, frequencyArray, control, rules, errors, setError, clearErrors, onInputChange }) => {
  const [selectedDay, setSelectedDay] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const days = Array.from({ length: 31 }, (_, i) => i + 1);

  const handleSelectDay = (day, fieldOnChange) => {
    setSelectedDay(day);
    clearErrors(name);
    fieldOnChange(day);
    onInputChange(day, name);
    setIsOpen(false);
  };

  useEffect(() => {
    if (value) {
      setSelectedDay(value)
    }
  }, [value])

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative w-full">
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <div>
            <div
              className={`rounded-lg ring-[1.5px] ring-[hsl(var(--border))] shadow-sm p-2 flex justify-between items-center cursor-pointer ${
                errors[name] ? "border-red-500" : "border-gray-300"
              }`}
              onClick={() => setIsOpen(!isOpen)}
            >
              <span>{selectedDay ? `Every ${selectedDay}th ${frequencyArray?.find((findDt) => findDt?.value === frequency)?.label}` : "Select"}</span><RiCalendar2Line size={20} color="hsl(var(--primary))" />
            </div>
            {isOpen && (
              <div ref={dropdownRef} className="absolute top-12 left-0 w-full bg-card shadow-lg rounded-md p-4 z-10">
                {selectedDay && <p className="text-sm text-gray-500 mb-2">Every {selectedDay}th {frequencyArray?.find((findDt) => findDt?.value === frequency)?.label}</p>}
                <div className="grid grid-cols-7 gap-2">
                  {days.map((day) => (
                    <button
                      key={day}
                      className={`w-10 h-9 rounded-full ${
                        selectedDay === day ? "bg-teal-600 text-white" : "hover:bg-gray-200"
                      }`}
                      onClick={() => handleSelectDay(day, field.onChange)}
                    >
                      {day}
                    </button>
                  ))}
                </div>
              </div>
            )}
            {errors[name] && (
              <p className="grc-error-msg text-danger">{errors[name].message}</p>
            )}
          </div>
        )}
      />
    </div>
  );
};

export default TimelineCalendar;
